export default "__VITE_ASSET__BLRHCLAu__"